import {
  Elevation
} from "./chunk-PK4FSMOO.mjs";
import {
  isDisabled,
  isFocused,
  isHovered,
  isNotDisabled
} from "./chunk-UW6KP2VA.mjs";
import {
  TransitionDuration
} from "./chunk-BRFMOBZJ.mjs";
import {
  __name,
  init_react_import
} from "./chunk-65BGW52G.mjs";

// mixins/hoverable.ts
init_react_import();
import { css } from "styled-components";
var hoverMixin = css`
  box-shadow: 0 0 0 3px transparent, ${Elevation.Mid};
`;
var focusMixin = /* @__PURE__ */ __name((variantArg) => css`
  ${({ theme, variant = "primary" }) => css`
      box-shadow: 0 0 0 3px ${theme.color.variants[variantArg || variant].highlight};
    `}
`, "focusMixin");
var hoverFocusMixin = /* @__PURE__ */ __name((variantArg) => css`
  ${({ theme, variant = "primary" }) => css`
      box-shadow: 0 0 0 3px ${theme.color.variants[variantArg || variant].highlight},
        ${Elevation.Mid};
    `}
`, "hoverFocusMixin");
var hoverableMixin = css`
  cursor: pointer;
  &${isDisabled} {
    cursor: not-allowed;
  }

  transition: box-shadow ${TransitionDuration.Fast};

  &${isHovered}${isNotDisabled} {
    ${hoverMixin};
  }
  &${isFocused}${isNotDisabled} {
    ${focusMixin()};
  }
  &${isHovered}${isFocused}${isNotDisabled} {
    ${hoverFocusMixin()};
  }
`;
var hoverable_default = hoverableMixin;

export {
  hoverMixin,
  focusMixin,
  hoverFocusMixin,
  hoverable_default
};
//# sourceMappingURL=chunk-B3YQD5BZ.mjs.map